import SEO from "@/components/SEO";
import Hero from "@/sections/Hero";
import Marquee from "@/components/Marquee";
import Demandas from "@/sections/Demandas";
import ComoAjudar from "@/sections/ComoAjudar";
import NeuroHighlight from "@/sections/NeuroHighlight";
import Publicos from "@/sections/Publicos";
import SobreTeaser from "@/sections/SobreTeaser";
import Comparativo from "@/sections/Comparativo";
import PorOndeComecarTeaser from "@/sections/PorOndeComecarTeaser";
import BlogTeaser from "@/sections/BlogTeaser";
import CtaBand from "@/sections/CtaBand";
import { PROFESSIONAL, WHATSAPP_NUMBER } from "@/data/site";

const jsonLd = {
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  name: PROFESSIONAL.brand,
  alternateName: "Sabrina Mota Psicóloga",
  description:
    "Psicologia Clínica e Neuropsicologia para crianças, adolescentes e adultos. Atendimento presencial em Taboão da Serra — SP e online.",
  telephone: "+55-11-99027-7456",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Estr. São Francisco, 2008 - Vila Sonia do Taboão, Metropolitan Office",
    addressLocality: "Taboão da Serra",
    addressRegion: "SP",
    postalCode: "06764-290",
    addressCountry: "BR",
  },
  founder: {
    "@type": "Person",
    name: PROFESSIONAL.fullName,
    jobTitle: "Psicóloga e Neuropsicóloga",
    identifier: PROFESSIONAL.crp,
  },
  areaServed: "Brasil",
  sameAs: ["https://www.instagram.com/sabrinamota.psi"],
  availableService: [
    { "@type": "Service", name: "Psicoterapia" },
    { "@type": "Service", name: "Avaliação Neuropsicológica" },
    { "@type": "Service", name: "Reavaliação Neuropsicológica" },
  ],
  contactPoint: {
    "@type": "ContactPoint",
    telephone: `+${WHATSAPP_NUMBER}`,
    contactType: "customer service",
    availableLanguage: "Portuguese",
  },
};

const Home = () => (
  <>
    <SEO
      title="Sabrina Mota — Psicóloga e Neuropsicóloga | Taboão da Serra e Online"
      description="Psicologia Clínica e Neuropsicologia para crianças, adolescentes e adultos. Psicoterapia e avaliação neuropsicológica em Taboão da Serra — SP e online, com Sabrina Mota — Psicóloga CRP 06/201923."
      path="/"
      jsonLd={jsonLd}
    />
    <Hero />
    <Marquee />
    <Demandas />
    <ComoAjudar />
    <NeuroHighlight />
    <Publicos />
    <SobreTeaser />
    <Comparativo />
    <PorOndeComecarTeaser />
    <BlogTeaser />
    <CtaBand />
  </>
);

export default Home;
